import { Injectable } from '@angular/core';

import { OnAppInit } from '@frontend/vanilla/core';

@Injectable()
export class HostBootstrapper implements OnAppInit {
    onAppInit() {}
}
